import { render, staticRenderFns } from "./signXiaoXiang.vue?vue&type=template&id=1eeb4a49"
import script from "./signXiaoXiang.vue?vue&type=script&lang=js"
export * from "./signXiaoXiang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports